import { DEFAULT_COUNTRY, DEFAULT_TELEPHONE_CODE } from "../shared/types";
import { CardholderPageModel } from "./types";
import { defaultAddress } from "../shared/defaults";
import type { EmploymentInfo } from "../../api/commercial/generated-types.ts";

export const defaultEmploymentInfoDocument: EmploymentInfo = {
  companyPosition: "",
  isCurrentlyEmployed: true,
  isInPermanentEmployment: true,
  isCrossBorderWorker: null,
  residencePermit: null,
  annualGrossIncome: null,
};

export const defaults: CardholderPageModel = {
  isSameAsAdmin: "yes",
  cardholder: {
    gender: "",
    firstName: "",
    lastName: "",
    fullStreet: "",
    address: defaultAddress(),
    phoneBusiness: {
      code: DEFAULT_TELEPHONE_CODE,
      number: "",
    },
    mobile: {
      code: DEFAULT_TELEPHONE_CODE,
      number: "",
    },
    emailBusiness: "",
    birthdate: "",
    nationality: DEFAULT_COUNTRY,
    correspondenceLanguage: "",
    companyPosition: "",
    spendingLimit: null,
    spendingLimitOther: null,
    isCurrentPermanentEmployee: "yes",
    isCrossBorderWorker: null,
    residencePermit: null,
  },
  hasDecentralizedInvoicing: undefined,
  decentralizedInvoicing: {
    bankAccount: {
      bankCode: "",
      bankName: "",
      iban: "",
    },
    fundsOwnership: undefined,
  },
  fundsOwnershipCardholder: {
    gender: "MALE",
    firstName: "",
    lastName: "",
    fullStreet: "",
    address: defaultAddress(),
    nationality: DEFAULT_COUNTRY,
    birthdate: "",
  },
};
